import { useMutation, useQueries, useQueryClient } from "@tanstack/react-query";

import { PER_PAGE_DEFAULT, QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import { fetchSalaryWorkers } from "./salaryWorkers";

export const fetchArrangement = async (year: any, companyId: any) => {
  return await axios({
    method: "get",
    url: SERVICES.ARRANGEMENTS,
    params: {
      company_id: companyId,
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
      "q[year_cycle_eq]": year,
    },
  }).then((res) => res.data || []);
};

export const usePromiseSettledArrangement = (year: any) => {
  const companyId = getCompanyId();
  const queryConfig = {
    staleTime: 300,
    cacheTime: 300,
    // retry: 1,
    enabled: !!year,
  };

  return useQueries({
    queries: [
      {
        queryKey: ["QUERY_NAME.ARRANGEMENTS", 1, year, companyId],
        queryFn: () => fetchArrangement(year, companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.ARRANGEMENTS", 2, year, companyId],
        queryFn: () => fetchSalaryWorkers(companyId),
        ...queryConfig,
      },
    ],
  });
};

export const useSubmitArrangement = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ payload }: any) =>
      axios({
        method: "post",
        url: SERVICES.ARRANGEMENTS_SAVE,
        data: payload,
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.ARRANGEMENTS]);
        // notification["success"]({
        //   message: "保存しました",
        // });
      },
    },
  );
};
